import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncMobileApp({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/mobileApp"));
  console.log("Loading", AsyncMobileApp.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncMobileApp;
